export default __webpack_public_path__ + "static/media/Skirmisher's Greatbow.94356c4f.jpg";